import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

const LayoutBuyingGuide = () =>
  dynamicImport(import('./pages/BuyingGuide/LayoutBuyingGuide'))

export default ({ country, config }) => {
  const useNewUrl = config.FF_NEW_URL_FORMAT.includes(country)

  return [
    {
      path: useNewUrl ? '/c' : '/content',
      name: ROUTES.BUYING_GUIDE.ROOT_HUB,
      component: () => dynamicImport(import('./pages/Hub/LayoutRootHub')),
    },
    {
      path: useNewUrl
        ? '/c/hub/:unifiedName'
        : '/content/:categories+-:id([0-9]+)',
      name: ROUTES.BUYING_GUIDE.HUB,
      component: () => dynamicImport(import('./pages/Hub/LayoutHub')),
    },
    {
      path: useNewUrl
        ? '/c/:category/:slug'
        : '/content/:category/:slug/:id([^-].*)',
      name: ROUTES.BUYING_GUIDE.SELF,
      component: LayoutBuyingGuide,
    },
  ]
}
